module.exports = __webpack_public_path__ + "static/media/team-3.9ca050de.png";